/* eslint-disable */
import { CompanyStore } from '../stores/company';
import {
    addNotification,
    apiMessagesSaveMessages,
    apiMessagesSaveMessagesV2,
    cleanApiMessages,
    cleanCatalogsStore,
    cleanCompaniesStore,
    cleanCountriesStore,
    cleanCurrenciesStore,
    cleanRatesStore,
    cleanUsersStore,
    getAuthAcceptanceDocuments,
    getCatalogsCompanyTypeSelect,
    getCatalogsDataUnitTypeSelect,
    getCatalogsPaymentTypeSelect,
    getCompaniesParents,
    getCountriesSelect,
    getCurrenciesSelect,
    getOperatorsSelect,
    getProfileStoreCurrentCompanyId,
    getProfileStoreIsCompanyTypeIdMNOHost,
    getProfileUserIsRoleRight,
    getRatesSelect,
    getStoreFeatureFlags,
    getUsersByCompanySelect,
    makeNewSelectList,
} from './';
import dayjs from 'dayjs';
import { appConfig } from '../settings';
import {
    IBodyItemResponse,
    IBodyListResponse,
    ILogoResp,
    ILogoRespAPI,
    IRequestAPIBody,
    IRequestIncludedItem,
    apiManager,
} from '../REST';
import {
    IAboutAPI,
    IAboutInfo,
    IAssignedCardSets,
    ICompanyApiKeyItem,
    ICompanyApiKeyList,
    ICompanyApiKeyListAPI,
    ICompanyCardSetsList,
    ICompanyConfig,
    ICompanyConfigAPI,
    ICompanyConfigAPIData,
    ICompanyConfigNewAlarmAPI,
    ICompanyConfigTypes,
    ICompanyCustomDocs,
    ICompanyForm,
    ICompanyGetAPI,
    ICompanyHierarchyV2APIItem,
    ICompanyIncludeOperatorPOSTAPI,
    ICompanyIncludeRateAPI,
    ICompanyInfo,
    ICompanyOperator,
    ICompanyOperatorList,
    ICompanyPostDataAttributesAPI,
    ICompanyRateItem,
    ICompanyRateList,
    ICompanyStatistics,
    ICompanySubscriptionInfo,
    ICompanySubscriptionsBody,
    ICompanySubscriptionsGetAPI,
    ICompanySubscriptionsGetAPIItem,
    ICompanyTenantConfig,
    ICompanyTenantConfigIncludeAPI,
    IEmailRecipient,
    IICompanyConfigTypesArr,
    IIMainUniversalUiItem,
    IIMainUniversalUiItemList,
    IIncludeCompanyOperatorGETAPI,
    IIncludeItemCardSetAPI,
    IIncludeItemCompanySalesRateAPI,
    IIncludeItemCurrencyAPI,
    IIncludeTypeAPI,
    IIncludeUserItemAPI,
    IItemAPI,
    IMakeRelationships,
    IMakeRelationshipsInclude,
    IMonthlyRecurringCharges,
    IMonthlyRecurringChargesAPI,
    INonRecurringCharges,
    INonRecurringChargesAPI,
    IParamsList,
    IPatchItem,
    IPostItem,
    IRelationshipItem,
    IRelationshipsItemPOSTAPI,
    ITypeAny,
    IUser,
    MfaType,
    NotificationType,
    companyConfigTypesFields,
    defaultCompanyTenantConfig,
} from '../interfaces';
import {
    IMapField,
    extractTrueFlags,
    getAPIUserFullName,
    globalHexId,
    intervalAPI2Ui,
    intervalUi2API,
    isNewId,
    mapApi2UiField,
    mapApi2UiList,
    mapUi2ApiField,
    unionStringArr,
} from '../instruments';

const mapAPICompanyTenantConfig = (apiCompany: ICompanyGetAPI): ICompanyTenantConfig => {
    const tenantConfigId = apiCompany?.data?.relationships?.tenant_config?.data?.id;
    const include = apiCompany.included?.filter((i) => i.type === 'tenant_config');
    const tenantConfigFind = include?.find((i) => i.id === tenantConfigId);
    if (!tenantConfigId || !tenantConfigFind?.attributes) {
        return defaultCompanyTenantConfig;
    } else {
        const { id, company_id, ...attributes } = tenantConfigFind.attributes as ICompanyTenantConfigIncludeAPI;
        return { ...mapApi2UiField(attributes), tenantConfigId: id };
    }
};

function mapAPIToCompanyInfo(apiCompany: ICompanyGetAPI): ICompanyInfo {
    const companyTypeId = apiCompany?.data?.relationships?.company_type?.data?.id;
    const companyTypeFind = apiCompany?.included?.find((i) => i.type === 'company_type' && i.id === companyTypeId);
    const companyType = (companyTypeFind as IItemAPI)?.attributes?.name;
    const parentId = apiCompany?.data?.relationships?.company_parent?.data?.id;
    const parentFind = apiCompany?.included?.find((i) => i.type === 'company_parent' && i.id === parentId);
    const parent = (parentFind as IItemAPI)?.attributes?.name;
    const primaryContactId = apiCompany?.data?.relationships?.primary_contact?.data?.id;
    const primaryContactFind = apiCompany?.included?.find(
        (i) => i.type === 'user' && i.id === primaryContactId,
    ) as IIncludeUserItemAPI;
    const primaryContact = getAPIUserFullName(primaryContactFind);
    const technicalContactId = apiCompany?.data?.relationships?.technical_contact?.data?.id;
    const financialContactId = apiCompany?.data?.relationships?.financial_contact?.data?.id;
    const countryId = apiCompany?.data?.relationships?.country?.data?.id;
    const currencyId = apiCompany?.data?.relationships?.currency?.data?.id;
    const currencyFind = apiCompany?.included?.find((i) => i.type === 'currency' && i.id === currencyId);
    const currency = (currencyFind as IIncludeItemCurrencyAPI)?.attributes?.abbreviation;
    const paymentTypeId = apiCompany?.data?.relationships?.payment_type?.data?.id;
    const paymentTypeFind = apiCompany?.included?.find(
        (i) => i.type === 'payment_type' && i.id === paymentTypeId,
    ) as IItemAPI;
    const paymentTypeName = paymentTypeFind?.attributes?.name;
    const sessionGrantedTypeId = apiCompany?.data?.relationships?.session_granted_type?.data?.id;
    const isHashed = apiCompany?.data?.attributes?.name === '******';
    const invoiceConfigurationId = apiCompany?.data?.relationships?.invoice_configuration?.data?.id;
    const companyCodeFound = apiCompany?.included?.find(
        (i) => i.type === 'invoice_configuration' && i.id === invoiceConfigurationId,
    ) as IItemAPI;

    const companyCode = companyCodeFound?.attributes?.company_code;
    const accountNumber = companyCodeFound?.attributes?.account_number;
    const invoiceFooter = companyCodeFound?.attributes?.invoice_footer;
    const iban = companyCodeFound?.attributes?.iban;
    const swift = companyCodeFound?.attributes?.swift;
    const isTenantConfig = !!apiCompany?.data?.relationships?.tenant_config?.data?.id;

    const {
        interval: cdrSquashIntervalValue,
        type: cdrSquashIntervalType,
        name: cdrSquashIntervalName,
    } = intervalAPI2Ui(apiCompany?.data?.attributes?.cdr_squash_interval);

    const tenantConfig = mapAPICompanyTenantConfig(apiCompany);

    let mapAttributes: ICompanyInfo = { id: apiCompany?.data?.id || '' };

    if (apiCompany?.data?.attributes) {
        mapAttributes = {
            ...mapAttributes,
            ...mapApi2UiField(apiCompany?.data?.attributes),
            ...tenantConfig,
            cdrSquashIntervalValue,
            cdrSquashIntervalName,
            cdrSquashIntervalType,
            companyType,
            companyTypeId,
            countryId,
            currency,
            currencyId,
            financialContactId,
            parent,
            parentId,
            paymentTypeId,
            paymentTypeName,
            primaryContact,
            primaryContactId,
            sessionGrantedTypeId,
            technicalContactId,
            privacyCdr: apiCompany?.data?.attributes?.privacy_cdr,
            companyCode,
            accountNumber,
            invoiceFooter,
            iban,
            isHashed,
            isTenantConfig,
            swift,
        };
    }

    return mapAttributes;
}

export function setCompanyInfoStore(company: ICompanyInfo): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setCompanyInfo(company);
}
export function setCompanyInfoBillingEmailsStore(changedBillingEmails?: Array<IEmailRecipient>): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setCompanyInfoBillingEmails(changedBillingEmails);
}

function setCompanyApiKeyList(list: ICompanyApiKeyList): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setApiKeysList(list);
}

export function setCompanyInfoStoreLogoBlobId(id: string, isDark?: boolean): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setCompanyInfoLogoBlobId(id, isDark);
}
export function setCompanyInfoStoreCleanLogoBlobId(isDark?: boolean): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.cleanCompanyInfoLogoBlobId(isDark);
}

export function setCompanyInfoStoreCleanLogoUrl(isDark?: boolean): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.cleanLogoUrl(isDark);
}

function setCompanyRateListStore(list: ICompanyRateList): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setCompanyRateList(list);
}

function updateCompanyRateListStore(list: ICompanyRateList): void {
    const CompanyInterface = CompanyStore.getInstance();
    const { rateList } = CompanyInterface;
    const newRates: ICompanyRateList = rateList.map((r: ICompanyRateItem) => {
        const newRate = list.find((i: ICompanyRateItem) => i.id === r.id);
        return newRate || r;
    });

    CompanyInterface.setCompanyRateList(newRates);
}

export function updateCompanyOperatorListStore(list: ICompanyOperatorList): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setCompanyOperatorList(list);
}

export function updateCompanyOperatorListStoreForm(list: Array<string> | string): void {
    const CompanyInterface = CompanyStore.getInstance();
    const operatorList = CompanyInterface.operatorList;
    const newList = Array.isArray(list) ? [...list] : [list];
    const newOperatorList = operatorList
        .map((i: ICompanyOperator) => ({ ...i, destroy: true }))
        .map((i: ICompanyOperator) => {
            const foundList = i.operatorId ? newList.indexOf(i.operatorId) : -1;
            if (foundList > -1) {
                newList.splice(foundList, 1);
                return { ...i, destroy: false };
            } else {
                return { ...i };
            }
        });

    newList.forEach((i: string) => {
        newOperatorList.push({ id: globalHexId.getId(), operatorId: i });
    });
    CompanyInterface.setCompanyOperatorList(newOperatorList);
}

function makeCompanySalesRateList(resp: ICompanyGetAPI): ICompanyRateList {
    const includeCSRL = resp.included?.filter((i) => i.type === 'company_sales_rate_list');
    const nameList = resp.included?.filter((i) => i.type === 'sales_rate_list');
    return (
        resp?.data?.relationships?.company_sales_rate_lists?.data?.map((c) => {
            const id = c.id;
            const includeCSRLFind = includeCSRL?.find((i) => i.id === id);
            const dateRange = (includeCSRLFind as IIncludeItemCompanySalesRateAPI)?.attributes;
            const rateId = (includeCSRLFind as IIncludeItemCompanySalesRateAPI)?.relationships?.sales_rate_list?.data
                ?.id;
            const rateFind = nameList?.find((i) => i.id === rateId);
            const rateName = (rateFind as IItemAPI)?.attributes?.name;
            const item: ICompanyRateItem = {
                ...mapApi2UiField(includeCSRLFind?.attributes || {}),
                id,
                rateId,
                rateName,
                startDate: dateRange?.start_date ? dayjs(dateRange?.start_date) : undefined,
                endDate: dateRange?.end_date ? dayjs(dateRange?.end_date) : undefined,
            };
            return item;
        }) || []
    );
}

export function addCompanyRate(item: ICompanyRateItem): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.addRate(item);
}

export function removeCompanyRateById(id: string): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.removeRateById(id);
}

function setCompanyUsersListStore(list: IUser[]): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setUsersList(list);
}

function makeCompanyUsersList(resp: ICompanyGetAPI): IUser[] {
    const nameList = resp.included?.filter((i) => i.type === 'user');
    const nameTypeList = resp.included?.filter((i) => i.type === 'user_type');
    return (
        resp?.data?.relationships?.users?.data?.map((u) => {
            const id = u.id;
            const nameFind = nameList?.find((i) => i.id === id);
            const userTypeId = (nameFind as IIncludeUserItemAPI)?.relationships?.user_type?.data?.id;
            const userType = (nameTypeList as IItemAPI[])?.find((i) => i.id === userTypeId)?.attributes?.name;

            return {
                id,
                userTypeId,
                userType,
                ...mapApi2UiField(nameFind?.attributes ? nameFind.attributes : {}),
            };
        }) || []
    );
}

function setCompanyCardSetsListStore(list: ICompanyCardSetsList): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setCardSetsList(list);
}

function makeCompanyCardSetsList(resp: ICompanyGetAPI): ICompanyCardSetsList {
    const assignedCompanyList = resp.included?.filter((i) => i.type === 'assigned_company');
    const cardSetsList = resp.included?.filter((i) => i.type === 'card_set');
    return (
        resp.data?.relationships?.card_sets?.data?.map((l) => {
            const id = l.id;
            const nameFind = (cardSetsList as IIncludeItemCardSetAPI[])?.find((n) => n.id === id);
            const assignedCompanyId = nameFind?.relationships?.assigned_company?.data?.id;
            const assignedCompanyFind = assignedCompanyList?.find((c) => c.id === assignedCompanyId);
            return {
                id,
                name: nameFind?.attributes?.name,
                cardsCount: nameFind?.attributes?.cards_count,
                assignedCompanyId,
                assignedCompany: (assignedCompanyFind as IItemAPI)?.attributes?.name,
            };
        }) || []
    );
}

function makeCompanyOperatorList(resp: ICompanyGetAPI): ICompanyOperatorList {
    const typeCO = 'companies_operators';
    const typeO = 'operator';
    const includeCO = resp.included?.filter((i) => i.type === typeCO);
    const includeO = resp.included?.filter((i) => i.type === typeO);
    const relationships = resp.data?.relationships?.[typeCO]?.data;
    return (
        relationships?.map((i: IRelationshipItem) => {
            const main = mapApi2UiField(i || {});
            const findCO = includeCO?.find((a) => a.id === i.id);
            const attributesCO = mapApi2UiField(findCO?.attributes || {});
            attributesCO.type && delete attributesCO.type;
            const operatorId = findCO && (findCO as IIncludeCompanyOperatorGETAPI).relationships?.operator?.data?.id;
            const findC = includeO?.find((a) => a.id === operatorId);
            const attributesC = mapApi2UiField(findC?.attributes || {});
            attributesC.type && delete attributesC.type;
            return { ...main, ...attributesCO, ...attributesC, id: i.id, operatorId: operatorId };
        }) || []
    );
}

function setBlobIds(apiCompany: ICompanyGetAPI): void {
    const logoBlobId = apiCompany?.data?.relationships?.logo_blob?.data?.id;
    const darkLogoBlobId = apiCompany?.data?.relationships?.dark_logo_blob?.data?.id;

    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setLogoBlobIds({ logoBlobId, darkLogoBlobId });
}

export const setCompanyTenantConfigStore = (config: ICompanyTenantConfig = defaultCompanyTenantConfig): void => {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setTenantConfig(config);
};

export async function getCompanyById(id: string): Promise<boolean> {
    const { resp, isError } = await apiManager.getApi('GET_COMPANY', { id: id });
    const respApi = resp as ICompanyGetAPI;

    if (!isError && respApi?.data?.id) {
        getCompanyAbout(respApi.data.id).then();
        getCompanySubscription(respApi.data.id).then();
        setCompanyInfoStore(mapAPIToCompanyInfo(respApi));
        setCompanyTenantConfigStore(mapAPICompanyTenantConfig(respApi));
        setCompanyRateListStore(makeCompanySalesRateList(respApi));
        setCompanyUsersListStore(makeCompanyUsersList(respApi));
        setCompanyCardSetsListStore(makeCompanyCardSetsList(respApi));
        updateCompanyOperatorListStore(makeCompanyOperatorList(respApi) as ICompanyOperatorList);
        setBlobIds(respApi);
    }
    return !isError;
}

export function setCompanyStatistics(statistics: ICompanyStatistics): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setCompanyStatistics(statistics);
}

export function setCompanySubscribersCsvBlobId(id?: string): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setCompanySubscribersCsvBlobId(id);
}

export async function getCompanyStatisticsById(id: string): Promise<boolean> {
    const { resp, isError } = await apiManager.getApi('GET_COMPANY_STATISTICS', { id: id });
    const respApi = resp as IBodyItemResponse;
    if (!isError && respApi?.data?.id) {
        const statistics: ICompanyStatistics = {
            id: respApi.data.id,
            companyId: id,
            ...mapApi2UiField(respApi?.data?.attributes),
        };

        setCompanyStatistics(statistics);
    }
    return isError;
}

export async function deleteBlob(id?: string): Promise<boolean> {
    const { isError } = await apiManager.getApi('DELETE_BLOB', { id: id });

    return isError;
}

export function setCompanyForm(form: ICompanyForm): void {
    const { salesRateList, operatorList: _, ...info } = form;
    updateCompanyRateListStore(salesRateList);
    setCompanyInfoStore(info);
}

const makeAPIUniversalRelationships = (list: IIMainUniversalUiItemList, type: IIncludeTypeAPI): IMakeRelationships => {
    const includedList: Array<IMakeRelationshipsInclude> = [];
    const newList = list
        .filter((i: IIMainUniversalUiItem) => !(i.destroy && isNewId(i.id)))
        .map((i: IIMainUniversalUiItem) => {
            const relation: IRelationshipsItemPOSTAPI = {
                id: i.id,
                type: type,
                destroy: i.destroy,
            };
            const includeAttributes = mapUi2ApiField(i);
            delete includeAttributes.id;
            delete includeAttributes.type;
            delete includeAttributes.name;
            delete includeAttributes.destroy;
            const include: IMakeRelationshipsInclude = {
                ...relation,
                type: type,
                attributes: includeAttributes,
            };
            includedList.push(include);
            return relation;
        });
    return { relationships: { [type]: { data: newList } }, included: includedList };
};

const updateCompanyTenantConfig = async (): Promise<boolean> => {
    const StoreInstance = CompanyStore.getInstance();
    const { tenantConfig, companyInfo } = StoreInstance;

    if (!!tenantConfig.tenantConfigId && !companyInfo.isTenantConfig) {
        await apiManager.getApi('DELETE_COMPANY_TENANT_CONFIG', { id: companyInfo.id });
        return false;
    } else if (!companyInfo.isTenantConfig) {
        return false;
    } else if (
        tenantConfig.bytesPerKb !== companyInfo.bytesPerKb ||
        tenantConfig.hideCosts !== companyInfo.hideCosts ||
        tenantConfig.minimumBillingDataUnits !== companyInfo.minimumBillingDataUnits ||
        tenantConfig.requireTariff !== companyInfo.requireTariff ||
        tenantConfig.showPackageData !== companyInfo.showPackageData ||
        tenantConfig.hideDataUsage !== companyInfo.hideDataUsage ||
        tenantConfig.hideSmsUsage !== companyInfo.hideSmsUsage ||
        tenantConfig.hideVoiceUsage !== companyInfo.hideVoiceUsage ||
        (!tenantConfig.tenantConfigId && companyInfo.isTenantConfig)
    ) {
        const newTenantConfig: ICompanyTenantConfig = {
            bytesPerKb: companyInfo.bytesPerKb,
            hideCosts: companyInfo.hideCosts,
            minimumBillingDataUnits: companyInfo.minimumBillingDataUnits,
            requireTariff: companyInfo.requireTariff,
            showPackageData: companyInfo.showPackageData,
            hideDataUsage: companyInfo.hideDataUsage,
            hideSmsUsage: companyInfo.hideSmsUsage,
            hideVoiceUsage: companyInfo.hideVoiceUsage,
        };
        const bodyTenantConfig: IRequestAPIBody = {
            ...mapUi2ApiField(newTenantConfig),
        };

        const { isError, resp } = await apiManager.getApi(
            'PUT_COMPANY_TENANT_CONFIG',
            { id: companyInfo.id },
            bodyTenantConfig,
        );
        apiMessagesSaveMessagesV2(resp.errors);

        return isError;
    } else {
        return false;
    }
};

export const saveCompany = async (isNew: boolean): Promise<boolean> => {
    const StoreInstance = CompanyStore.getInstance();
    const { id, ...companyInfo } = StoreInstance.companyInfo;
    companyInfo.cdrSquashInterval = intervalUi2API(
        companyInfo.cdrSquashIntervalValue,
        companyInfo.cdrSquashIntervalType,
    );

    delete companyInfo.companyType;
    delete companyInfo.parent;
    delete companyInfo.primaryContact;
    delete companyInfo.cdrSquashIntervalValue;
    delete companyInfo.cdrSquashIntervalType;
    delete companyInfo.cdrSquashIntervalName;
    if (!getProfileUserIsRoleRight('ROOT')) delete companyInfo.billingCycleStartDay;

    companyInfo.subscribersCsvBlobId = StoreInstance.companySubscribersCsvBlobId;

    const attributes: ICompanyPostDataAttributesAPI = mapUi2ApiField(companyInfo);

    const companiesRelationshipsRates = makeAPIUniversalRelationships(
        StoreInstance.rateList,
        'apply_company_sales_rate_lists',
    );

    const companiesRelationshipsOperators = makeAPIUniversalRelationships(
        StoreInstance.operatorList,
        'companies_operators',
    );

    const companiesRelationshipsRateInclude: Array<ICompanyIncludeRateAPI> =
        companiesRelationshipsRates?.included?.map((i: ITypeAny) => {
            return {
                ...i,
                attributes: {
                    sales_rate_list_id: i.attributes.rate_id,
                    start_date: i.attributes.start_date
                        ? dayjs(i.attributes.start_date).format(appConfig.formatDate)
                        : undefined,
                    end_date: i.attributes.end_date
                        ? dayjs(i.attributes.end_date).format(appConfig.formatDate)
                        : undefined,
                },
            };
        }) || [];

    const companiesRelationshipsOperatorsIncluded: Array<ICompanyIncludeOperatorPOSTAPI> =
        companiesRelationshipsOperators?.included?.map((i: ITypeAny) => {
            return { ...i };
        }) || [];

    const body: IRequestAPIBody = {
        data: {
            type: 'company',
            attributes: attributes,
            relationships: {
                ...companiesRelationshipsRates.relationships,
                ...companiesRelationshipsOperators.relationships,
            },
        },
        included: [...companiesRelationshipsRateInclude, ...companiesRelationshipsOperatorsIncluded],
    };

    const { resp, isError } = await apiManager.getApi(
        isNew ? 'POST_COMPANY' : 'PATCH_COMPANY',
        isNew ? {} : { id },
        body,
    );

    const { errors, data } = resp;

    const companyId = isNew && !isError ? (data as IItemAPI)?.id : id;

    let isErrorTenantConfig = false;
    let isErrorPatchCompanyConfigMFA = false;
    if (isError) {
        if (Array.isArray(errors)) {
            apiMessagesSaveMessages(errors);
        } else {
            apiMessagesSaveMessagesV2(resp.errors);
        }
    } else {
        isErrorPatchCompanyConfigMFA = await patchCompanyConfigMFA(companyId);
        isErrorTenantConfig = await updateCompanyTenantConfig();
    }

    return isError || isErrorPatchCompanyConfigMFA || isErrorTenantConfig;
};

export const updateCompanyInfoStore = (updatedInfo: ICompanyInfo): void => {
    const StoreInstance = CompanyStore.getInstance();
    const companyInfo = StoreInstance.companyInfo;
    StoreInstance.setCompanyInfo({ ...companyInfo, ...updatedInfo });
};
export const updateCompanySubscribersMigrate = async (onPerm: boolean): Promise<void> => {
    const StoreInstance = CompanyStore.getInstance();
    const { id } = StoreInstance.companyInfo;

    const { resp, isError, errors } = await apiManager.getApi(
        'POST_COMPANY_SUBSCRIBERS_MIGRATE',
        { id: id },
        { migrated: onPerm },
    );
    const respApi = resp as ICompanyGetAPI;

    if (isError) {
        addNotification({
            type: NotificationType.ERROR,
            message: `Subscribers Migrate`,
            isUsersError: true,
            isTranslated: true,
            description: JSON.stringify(errors),
        });
    } else {
        updateCompanyInfoStore(mapApi2UiField(respApi?.data?.attributes || {}) as ICompanyInfo);
    }
};

export function setCompanyAboutStore(about: IAboutInfo): void {
    const StoreInstance = CompanyStore.getInstance();
    StoreInstance.setAbout(about);
}

export async function getCompanyLogo(slug: string): Promise<ILogoResp> {
    const response = await apiManager.getApi('GET_COMPANY_LOGO', { id: slug });
    const { isError, resp } = response;

    const logos = resp as ILogoRespAPI;
    return (
        isError
            ? {}
            : {
                  logoWhite: logos.logo_url,
                  logoBlack: logos.dark_logo_url,
                  website: logos.website,
                  customLogoLink: logos.custom_logo_link_url,
              }
    ) as ILogoResp;
}

export async function getCompanyAbout(companyId: string): Promise<void> {
    const response = await apiManager.getApi('GET_COMPANY_ABOUT', { id: companyId });
    const { isError, resp } = response;
    if (!isError) {
        const aboutResp = resp as IAboutAPI;
        const about: IAboutInfo = {
            ...mapApi2UiField(aboutResp?.data?.attributes || {}),
        };
        setCompanyAboutStore(about);
    }
}

export async function saveCompanyAbout(id: string, fields: IMapField): Promise<IPatchItem> {
    const apiBody: IRequestAPIBody = {
        data: {
            type: 'about',
            id: id,
            attributes: mapUi2ApiField(fields),
        },
    };

    const { resp, isError } = await apiManager.getApi('PATCH_COMPANY_ABOUT', { id }, apiBody);
    const { errors } = await resp;
    return { isError, errors };
}

export async function saveCompanyCustomDocs({
    companyId,
    blobId,
    docType,
    file,
}: ICompanyCustomDocs): Promise<IPatchItem> {
    const apiBody: IRequestAPIBody = {
        data: {
            attributes: {
                name: file?.name,
                key: file?.name,
                domain: docType,
                company_id: companyId,
                document_file_blob_id: blobId,
            },
            type: 'acceptance_document',
        },
    };

    const { resp, isError } = await apiManager.getApi('POST_UPLOAD_ACCEPTANCE_DOCUMENTS', {}, apiBody);
    const { errors } = await resp;
    return { isError, errors };
}

function formatCompanyApiKeyList(list: ICompanyApiKeyListAPI): ICompanyApiKeyList {
    const { api_keys } = list;

    return api_keys.map((value) => {
        return mapApi2UiField(value) as ICompanyApiKeyItem;
    });
}

export async function getCompanyApiKeysList(): Promise<void> {
    const { resp, isError } = await apiManager.getApi('GET_COMPANY_API_KEY');

    if (!isError) {
        const list = resp as ICompanyApiKeyListAPI;
        setCompanyApiKeyList(formatCompanyApiKeyList(list));
    }
}

export async function postCompanyApiKey(): Promise<{
    newApiKey: ICompanyApiKeyItem;
    isError: boolean;
    resp: IBodyItemResponse;
}> {
    const { resp, isError } = await apiManager.getApi('POST_COMPANY_API_KEY');

    const newApiKey = mapApi2UiField(resp) as ICompanyApiKeyItem;
    const response = resp as IBodyItemResponse;

    return { newApiKey, isError, resp: response };
}

export async function deleteCompanyApiKey(id: string): Promise<boolean> {
    const { isError } = await apiManager.getApi('DELETE_COMPANY_API_KEY', { id });

    return isError;
}

function formatCompanySubscription(resp: ICompanySubscriptionsGetAPI): ICompanySubscriptionInfo {
    const subscriptionInfo = resp?.user_subscriptions?.[0] as ICompanySubscriptionsGetAPIItem;

    return { ...mapApi2UiField(subscriptionInfo || {}) };
}

export function setCompanySubscription(subscription: ICompanySubscriptionInfo): void {
    const StoreInstance = CompanyStore.getInstance();
    StoreInstance.setSubscription(subscription);
}

export async function getCompanySubscription(id: string): Promise<ICompanySubscriptionInfo> {
    const { resp, isError } = await apiManager.getApi('GET_COMPANY_SUBSCRIPTION', { id });

    const subscriptions = formatCompanySubscription(resp as ICompanySubscriptionsGetAPI);

    if (!isError) {
        setCompanySubscription(subscriptions);
    }

    return subscriptions;
}

export async function createCompanySubscription(
    companyId: string,
    attributes: ICompanySubscriptionsBody,
): Promise<IPostItem> {
    const apiBody = {
        user_subscription: {
            ...attributes,
        },
    } as unknown as IRequestAPIBody;

    const { isError, resp } = await apiManager.getApi('CREATE_COMPANY_SUBSCRIPTION', { id: companyId }, apiBody);
    const response = resp as IBodyItemResponse;

    return { isError, resp: response };
}

export async function editCompanySubscription(
    companyId: string,
    subscriptionId: string,
    attributes: ICompanySubscriptionsBody,
): Promise<IPostItem> {
    const apiBody = {
        user_subscription: {
            ...attributes,
        },
    } as unknown as IRequestAPIBody;

    const { isError, resp } = await apiManager.getApi(
        'PATCH_COMPANY_SUBSCRIPTION',
        { id: companyId, subscriptionId },
        apiBody,
    );

    const response = resp as IBodyItemResponse;

    return { isError, resp: response };
}

export const postCompanySubscriptionOrder = async (
    subscriptionId: string,
    attributes: ICompanySubscriptionsBody,
): Promise<IPostItem> => {
    const body: IRequestAPIBody = {
        order: { ...mapUi2ApiField(attributes), orderable_id: subscriptionId },
    };

    const { resp, isError } = await apiManager.getApi('POST_NEW_ORDER', { id: '1' }, body);
    const response = resp as IBodyItemResponse;
    const { errors } = response;
    return { isError, errors, resp: response };
};

export const deleteCompanySubscription = async (companyId: string, subscriptionId: string): Promise<boolean> => {
    const { isError } = await apiManager.getApi('DELETE_COMPANY_SUBSCRIPTION', { id: companyId, subscriptionId });

    return isError;
};

export function getCompanyRelationSelect(): void {
    cleanApiMessages();
    getCatalogsCompanyTypeSelect().then();
    getCatalogsPaymentTypeSelect().then();
    getCompaniesParents().then();
    getCountriesSelect().then();
    const isCompanyTypeIdMNOHost = getProfileStoreIsCompanyTypeIdMNOHost();
    if (!isCompanyTypeIdMNOHost) {
        getCurrenciesSelect().then();
    }
    getRatesSelect().then();
    getOperatorsSelect().then();
    getCompanyMFASelect().then();
}

export function getCompanyRelationById(id: string): void {
    getCompanyConfig(id).then();
    getMonthlyRecurringChargesList(id).then();
}

export function getCompanyRelationSelectById(id: string): void {
    getUsersByCompanySelect(id).then();
    getAuthAcceptanceDocuments(id).then();
    getCatalogsDataUnitTypeSelect().then();
    getNonRecurringChargesList(id).then();
}

export function cleanCompanyRelationSelect(): void {
    cleanApiMessages();
    cleanCatalogsStore();
    cleanCompaniesStore();
    cleanCountriesStore();
    cleanCurrenciesStore();
    cleanRatesStore();
}

export function clearCompanyStatistics(): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.clearCompanyStatistics();
}

export function cleanCompanyStore(): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.cleanStore();
}

function formatMonthlyRecurringChargesList(resp: IMonthlyRecurringChargesAPI): IMonthlyRecurringCharges {
    const monthlyRecurringCharges = mapApi2UiList(resp.monthly_recurring_charges) as IMonthlyRecurringCharges;

    return monthlyRecurringCharges.map((value) => {
        value.amountCents = value.amountCents / 100;

        return value;
    });
}

export function setMonthlyRecurringChargesList(value: IMonthlyRecurringCharges): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setMonthlyRecurringCharges(value);
}

export function setFreezingPeriod(value: boolean): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setIsFreezingPeriod(value);
}

export async function getMonthlyRecurringChargesList(id: string): Promise<void> {
    const { resp, isError } = await apiManager.getApi('GET_COMPANY_MONTHLY_PAYMENTS', { companyId: id });

    const response = resp as IMonthlyRecurringChargesAPI;

    if (!isError) {
        setMonthlyRecurringChargesList(formatMonthlyRecurringChargesList(response));
        setFreezingPeriod(response?.meta?.is_freezing_period);
    }
}

export async function postMonthlyRecurringChargesList(id: string, body: any): Promise<IPostItem> {
    const formattedBody = mapUi2ApiField(body);

    const { resp, isError } = await apiManager.getApi(
        'POST_COMPANY_MONTHLY_PAYMENTS',
        { companyId: id },
        formattedBody,
    );

    const response = resp as IBodyItemResponse;

    return { isError, resp: response };
}

export async function putMonthlyRecurringChargesList(
    id: string,
    companyId: string,
    formattedBody: any,
): Promise<IPostItem> {
    const { resp, isError } = await apiManager.getApi('PUT_COMPANY_MONTHLY_PAYMENTS', { companyId, id }, formattedBody);

    const response = resp as IBodyItemResponse;

    return { isError, resp: response };
}

export async function deleteMonthlyRecurringChargesList(id: string, companyId: string): Promise<IPostItem> {
    const { resp, isError } = await apiManager.getApi('DELETE_COMPANY_MONTHLY_PAYMENTS', {
        companyId,
        id,
    });

    const response = resp as IBodyItemResponse;

    return { isError, resp: response };
}

////////////////////

function formatNonRecurringChargesList(resp: INonRecurringChargesAPI): INonRecurringCharges {
    const nonRecurringCharges = mapApi2UiList(resp.non_recurring_charges) as INonRecurringCharges;

    return nonRecurringCharges.map((value) => {
        value.amountCents = value.amountCents / 100;

        return value;
    });
}

export function setNonRecurringChargesList(value: INonRecurringCharges): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setNonRecurringCharges(value);
}

export async function getNonRecurringChargesList(id: string): Promise<void> {
    const { resp, isError } = await apiManager.getApi('GET_COMPANY_NON_RECURRING_PAYMENTS', { companyId: id });

    if (!isError) {
        setNonRecurringChargesList(formatNonRecurringChargesList(resp as INonRecurringChargesAPI));
    }
}

export async function getNonRecurringCardsCount(companyId: string, params: IParamsList): Promise<number> {
    const { resp } = await apiManager.getApi('GET_COMPANY_NRC_COUNT_CARDS', {
        companyId,
        searchParamsList: {
            ...params,
        },
    });

    return resp.count || 0;
}

export async function postNonRecurringChargesList(id: string, body: any): Promise<IPostItem> {
    const formattedBody = mapUi2ApiField(body);

    formattedBody.amount_cents = formattedBody.amount_cents * 100;

    const { resp, isError } = await apiManager.getApi(
        'POST_COMPANY_NON_RECURRING_PAYMENTS',
        { companyId: id },
        formattedBody,
    );

    const response = resp as IBodyItemResponse;

    return { isError, resp: response };
}

export async function putNonRecurringChargesList(id: string, companyId: string, body: any): Promise<IPostItem> {
    const formattedBody = mapUi2ApiField(body);

    formattedBody.amount_cents = formattedBody.amount_cents * 100;

    const { resp, isError } = await apiManager.getApi(
        'PUT_COMPANY_NON_RECURRING_PAYMENTS',
        { companyId, id },
        formattedBody,
    );

    const response = resp as IBodyItemResponse;

    return { isError, resp: response };
}

export async function deleteNonRecurringChargesList(id: string, companyId: string): Promise<IPostItem> {
    const { resp, isError } = await apiManager.getApi('DELETE_COMPANY_NON_RECURRING_PAYMENTS', {
        companyId,
        id,
    });

    const response = resp as IBodyItemResponse;

    return { isError, resp: response };
}

export async function getCompanyHierarchyV2(): Promise<ICompanyHierarchyV2APIItem> {
    const { resp } = await apiManager.getApi('GET_COMPANY_HIERARCHY_V2');

    return resp as ICompanyHierarchyV2APIItem;
}

export const showMFAValue = (value?: string, mfaForcedBy?: string): string => {
    if (mfaForcedBy) {
        return `Enforced by ${mfaForcedBy}`;
    } else {
        switch (value) {
            case 'disabled':
                return 'Disabled';
            case 'this':
                return 'Enforced for this company';
            case 'children':
                return 'Enforced for customer companies';
            case 'this_and_children':
                return 'Enforced for this company and customer companies';
            default:
                return `${value ? value : ''}`;
        }
    }
};

const getMFAName = (id: string, name: string): string => {
    switch (id) {
        case 'disabled':
            return 'Disabled';
        case 'this':
            return 'This company only';
        case 'children':
            return 'Customer companies';
        case 'this_and_children':
            return 'This company and customer companies';
        default:
            return name;
    }
};

function setCompanyMFASelect(apiList: IBodyListResponse): void {
    const CompanyInterface = CompanyStore.getInstance();
    const select = makeNewSelectList(apiList, 'mfa').map((i) => ({ ...i, name: getMFAName(i.id, i.name) }));
    CompanyInterface.setMFASelect(select);
}

// ------------ CompanyConfig ------------

export async function getCompanyMFASelect(): Promise<void> {
    const { resp } = await apiManager.getApi('GET_COMPANY_CONFIG_MFA_SELECT');
    resp && setCompanyMFASelect(resp as IBodyListResponse);
}

const mapCompanyConfigNewAlarm = (resp: ICompanyConfigNewAlarmAPI): ICompanyConfig => {
    const { events, ...other } = resp;
    const companyConfig: ICompanyConfig = { id: '', ...mapApi2UiField(other || {}) };
    events?.forEach((value: ICompanyConfigTypes) => {
        companyConfig[value] = true;
    });
    if (companyConfig.cardSetIds?.length) {
        companyConfig.cardSetIds = companyConfig.cardSetIds.map((i) => i.toString());
    }
    if (companyConfig.cardSetTotalIds?.length) {
        companyConfig.cardSetTotalIds = companyConfig.cardSetTotalIds.map((i) => i.toString());
    }

    return companyConfig;
};

function mapCompanyConfig(resp: ICompanyConfigAPI): ICompanyConfig {
    const { data, included } = resp;
    const eventArr = data?.attributes?.events;
    const notifications: { [key: string]: boolean } = {};
    eventArr?.forEach((value) => {
        notifications[value] = true;
    });
    const attributes = mapApi2UiField(data?.attributes || {});
    const cardLimit = data?.attributes?.card_limit || 0;
    const cardSetLimit = data?.attributes?.card_set_limit || 0;
    const foundCardSets = included?.filter((i) => i.type === 'card_set');
    const cardSetIds = foundCardSets?.map((i) => i.id);
    const cardSetRecordMap: { [key: string]: string } = {};

    included?.forEach((value) => {
        if (value.type === 'company_configs_card_set') {
            const cardSetId = value?.relationships?.card_set?.data?.id;
            if (cardSetId) {
                cardSetRecordMap[cardSetId] = value.id;
            }
        }
    });

    return {
        id: data.id,
        ...attributes,
        ...notifications,
        cardLimit,
        cardSetLimit,
        cardSetIds,
        cardSetRecordMap,
    };
}

export async function patchCompanyConfigMFA(companyId: string): Promise<boolean> {
    const companyConfig = getStoreCompanyConfig();
    if (!companyConfig.mfaForcedBy) {
        const data: ICompanyConfigAPIData = {
            type: 'company_config',
            id: companyConfig.id,
            attributes: {
                mfa: companyConfig.mfa,
            },
        };

        const body = {
            data,
        } as IRequestAPIBody;

        const { isError, errors } = await apiManager.getApi('PATCH_COMPANY_CONFIG', { id: companyId }, body);

        if (isError) {
            apiMessagesSaveMessages(errors);
        }
        return isError;
    }
    return false;
}

export async function saveProfileOldAlarms(values: ICompanyConfig): Promise<boolean> {
    const companyId = getProfileStoreCurrentCompanyId();
    const companyConfig = getStoreCompanyConfig();
    const currentCardSets = companyConfig.cardSetIds || [];
    const cardSetRecordMap = companyConfig.cardSetRecordMap || {};
    const newCardSets = values.cardSetIds || [];
    const cardSetsIds = unionStringArr(newCardSets, currentCardSets);

    const assignedCardSetsArr: IAssignedCardSets[] = cardSetsIds?.map((cardSetId) => {
        const destroy = currentCardSets.includes(cardSetId) && !newCardSets?.includes(cardSetId);
        const isAlreadyAssigned = currentCardSets.includes(cardSetId) && newCardSets?.includes(cardSetId);
        const foundCardSet = cardSetRecordMap[cardSetId];

        return {
            id: destroy || isAlreadyAssigned ? `${foundCardSet}` : globalHexId.getId(),
            type: 'company_configs_card_set',
            cardSetId: `${cardSetId}`,
            destroy,
            isAlreadyAssigned,
        };
    });

    const filteredAlreadyAssignedArr: IAssignedCardSets[] = assignedCardSetsArr?.filter((value: IAssignedCardSets) => {
        return !value.isAlreadyAssigned;
    });

    const relationshipsCompanyCarSet: IRelationshipItem[] = filteredAlreadyAssignedArr?.map(
        (value: IAssignedCardSets) => {
            return {
                id: value.id,
                type: value.type,
                destroy: value.destroy,
            };
        },
    );

    const included: IRequestIncludedItem[] = filteredAlreadyAssignedArr
        ?.filter((value: IAssignedCardSets) => {
            return !value.destroy;
        })
        ?.map((value) => {
            return {
                id: value.id,
                type: value.type,
                attributes: {
                    card_set_id: value.cardSetId,
                },
            };
        });

    const cardSetLimit = values.cardSetLimit || 0;
    const cardLimit = values.cardLimit || 0;

    delete values.cardSetIds;
    delete values.cardSetLimit;
    delete values.cardLimit;

    const notificationsEntries = Object.entries(values).filter((value) => {
        return value[1];
    });

    const notifications: IICompanyConfigTypesArr = notificationsEntries.map((value) => {
        return value[0] as ICompanyConfigTypes;
    });

    const data: ICompanyConfigAPIData = {
        type: 'company_config',
        id: companyConfig.id,
        attributes: {
            events: [...notifications],
            alarm_emails: values.alarmEmails,
            card_set_limit: +cardSetLimit || null,
            card_limit: +cardLimit || null,
        },
        relationships: {
            company_configs_card_sets: {
                data: relationshipsCompanyCarSet,
            },
        },
    };

    const body = {
        data,
        included,
    } as IRequestAPIBody;

    const { isError, resp } = await apiManager.getApi('PATCH_COMPANY_CONFIG', { id: companyId }, body);
    if (isError) {
        apiMessagesSaveMessagesV2(resp.errors);
    }

    return isError;
}

export async function saveProfileNewAlarms(values: ICompanyConfig): Promise<boolean> {
    const companyId = getProfileStoreCurrentCompanyId();
    const { trueKeysArr, restObj } = extractTrueFlags(values, companyConfigTypesFields);
    const bodyValues: ICompanyConfig = {
        ...restObj,
        cardLimit: values.cardLimit,
        cardSetIds: values.cardSetIds || [],
        cardSetLimit: values.cardSetLimit,
        cardSetTotalIds: values.cardSetTotalIds || [],
        cardSetTotalLimit: values.cardSetTotalLimit,
        mfa: values.mfa,
        mfaForcedBy: values.mfaForcedBy,
    };
    const body: ICompanyConfigNewAlarmAPI = { ...mapUi2ApiField(bodyValues), events: trueKeysArr };

    const { isError, resp } = await apiManager.getApi(
        'PATCH_COMPANY_CONFIG',
        { id: companyId },
        body as IRequestAPIBody,
    );
    if (isError) {
        apiMessagesSaveMessagesV2(resp.errors);
    }

    return isError;
}

export async function saveProfileAlarms(values: ICompanyConfig): Promise<boolean> {
    const { newAlarms } = getStoreFeatureFlags();
    if (newAlarms) {
        return saveProfileNewAlarms(values);
    } else {
        return saveProfileOldAlarms(values);
    }
}
export function getMyAlarmRelationSelectors(companyId: string): void {
    getUsersByCompanySelect(companyId);
}
export function cleanMyAlarmRelationSelectors(): void {
    cleanUsersStore();
}

export async function getCompanyConfig(id: string): Promise<void> {
    const { isError, resp } = await apiManager.getApi('GET_COMPANY_CONFIG', { id });
    const { newAlarms } = getStoreFeatureFlags();

    if (!isError && !!resp) {
        if (newAlarms) {
            setCompanyConfig(mapCompanyConfigNewAlarm(resp as ICompanyConfigNewAlarmAPI));
        } else {
            setCompanyConfig(mapCompanyConfig(resp as unknown as ICompanyConfigAPI));
        }
    }
}

export function getStoreCompanyConfig(): ICompanyConfig {
    const CompanyInterface = CompanyStore.getInstance();
    return CompanyInterface.companyConfig;
}

export function setCompanyConfig(alarmInfo: ICompanyConfig): void {
    const CompanyInterface = CompanyStore.getInstance();
    CompanyInterface.setCompanyConfig(alarmInfo);
}

export function setCompanyConfigMFA(mfa: MfaType): void {
    const CompanyInterface = CompanyStore.getInstance();
    const { companyConfig } = CompanyInterface;
    CompanyInterface.setCompanyConfig({ ...companyConfig, mfa });
}
